<template>
  <div class="related_box">
    <div class="related_news">
      <div class="labelbar">相关推荐</div>
    </div>
    <ul class="news_list">
      <li v-for="item in newsList" :key="item.id">
        <!-- 活动、小图 -->
        <div class="news_item news_item_activity news_item_small" v-if="item.contentType == 1 && ( item.styleType == 2 || item.styleType == 0)" @click="toDetail(item)">
          <div class="news_text">
            <div class="news_title" v-text="item.title"></div>
            <div class="news_info">
              <span class="time" style="margin:0;">时间：{{ item.startTime.substring(0,10) }}—{{ item.endTime.substring(0,10) }}</span>
            </div>
          </div>
          <div class="thumbnail">
            <img :src="item.imgList[0].url" :onerror="imgLoadError(item)" v-if="item.imgList && item.imgList.length > 0 && item.imgList[0].url.length>0" alt="" />
          </div>
        </div>
        <!-- 活动、大图 -->
        <div class="news_item news_item_activity" v-if="item.contentType == 1 && item.styleType == 3" @click="toDetail(item)">
          <div class="title" v-text="item.title"></div>
          <div class="news_activity_img_box">
            <div class="news_activity_img">
              <img :src="item.imgList[0].bigUrl" :onerror="imgLoadError(item)" v-if="item.imgList && item.imgList.length > 0 && item.imgList[0].bigUrl.length>0" alt="" />
            </div>
            <div class="activity_info">
              <span class="status not_start" v-if="item.status == 1">活动未开始</span>
              <span class="status playing" v-else-if="item.status == 2">正在进行</span>
              <span class="status end" v-else-if="item.status == 3">活动结束</span>
              <span class="status end" v-else>草稿</span>
              <span class="time">时间：{{ item.startTime.substring(0,10) }} — {{ item.endTime.substring(0,10) }}</span>
            </div>
          </div>
        </div>
        <!-- 投票、小图 -->
        <div class="news_item news_item_vote news_item_small" v-else-if="item.contentType == 3 && ( item.styleType == 2 || item.styleType == 0)" @click="toDetail(item)">
          <div class="news_text">
            <div class="news_title" v-text="item.title"></div>
            <div class="news_info">
              <span class="time" style="margin:0;">投票时间：{{ item.startTime.substring(0,10) }}—{{ item.endTime.substring(0,10) }}</span>
            </div>
          </div>
          <div class="thumbnail">
            <img :src="item.imgList[0].url" :onerror="imgLoadError(item)" v-if="item.imgList && item.imgList.length > 0 && item.imgList[0].url.length>0" alt="" />
          </div>
        </div>
        <!-- 投票、大图 -->
        <div class="news_item news_item_vote" v-else-if="item.contentType == 3 && item.styleType == 3" @click="toDetail(item)">
          <div class="title" v-text="item.title"></div>
          <div class="news_vote_img_box">
            <div class="news_vote_img">
              <img :src="item.imgList[0].bigUrl" :onerror="imgLoadError(item)" v-if="item.imgList && item.imgList.length > 0 && item.imgList[0].bigUrl.length>0" alt="" />
            </div>
            <div class="vote_info">
              <span class="status not_start" v-if="item.status == 1">投票未开始</span>
              <span class="status playing" v-else-if="item.status == 2">正在进行</span>
              <span class="status end" v-else-if="item.status == 3">投票结束</span>
              <span class="time">投票时间：{{ item.startTime.substring(0,10) }} — {{ item.endTime.substring(0,10) }}</span>
            </div>
          </div>
        </div>
        <!-- 直播 -->
        <div class="news_item news_item_live" v-else-if="item.contentType == 4" @click="toDetail(item)">
          <div class="news_live_box">
            <div class="news_live_img">
              <img :src="item.imgList[0].bigUrl" :onerror="imgLoadError(item)" v-if="!!item.imgList && item.imgList.length > 0&& item.imgList[0].bigUrl.length>0" />
            </div>
            <div class="news_info">
              <div class="title" v-text="item.title"></div>
              <span class="play_status not_start" v-if="!item.status || item.status == 1">
                <Icon iconClass="clock" /><span>预约</span>
              </span>
              <span class="play_status playing" v-if="item.status == 2"><span>直播中</span></span>
              <span class="play_status end" v-if="item.status == 3">
                <Icon iconClass="replay" /><span>回顾</span>
              </span>
              <span class="start_time" v-text="item.startTime"></span>
            </div>
          </div>
        </div>
        <!-- 图文、无图 -->
        <div class="news_item" v-else-if="item.contentType==5 && item.styleType == 1" @click="toDetail(item)">
          <div class="news_title" v-text="item.title"></div>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 图文、小图 -->
        <div class="news_item news_item_small" v-else-if="item.contentType==5 && ( item.styleType == 2 || item.styleType == 0)" @click="toDetail(item)">
          <div class="news_text">
            <div class="news_title" v-text="item.title"></div>
            <div class="news_info">
              <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
              <span class="source" v-text="appName" v-else></span>
              <span class="time" v-text="item.publishTime"></span>
            </div>
          </div>
          <div class="thumbnail">
            <img :src="item.imgUrl" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgUrl && item.imgUrl.length > 0" />
            <img :src="item.imgList[0].url" alt="" :onerror="imgLoadError(item)" v-else-if="!!item.imgList && item.imgList.length > 0" />
          </div>
        </div>
        <!-- 图文、大图 -->
        <div class="news_item news_item_big" v-else-if="item.contentType==5 && item.styleType == 3" @click="toDetail(item)">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <div class="news_big_img_box">
            <div class="news_big_img">
              <img :src="item.imgList[0].bigUrl" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgList && item.imgList.length > 0" />
            </div>
          </div>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 图文、三图 -->
        <div class="news_item news_item_three" v-else-if="item.contentType==5 && item.styleType == 4" @click="toDetail(item)">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <van-row class="news_img_list" v-if="!!item.pictureUrls && item.pictureUrls.length > 0">
            <van-col span="8" v-for="(pic, i) in item.pictureUrls" :key="i">
              <div class="news_img_item">
                <div class="news_img_box">
                  <img :src="pic" alt="" :onerror="imgLoadError(item)" v-if="pic.length > 0" />
                </div>
              </div>
            </van-col>
          </van-row>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 图文、ES搜索的结果 -->
        <div class="news_item news_item_small" v-else-if="item.contentType==5" @click="toDetail(item)">
          <div class="news_text">
            <div class="news_title" v-text="item.title"></div>
            <div class="news_info">
              <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
              <span class="source" v-text="appName" v-else></span>
              <span class="time" v-text="item.publishTime"></span>
            </div>
          </div>
          <div class="thumbnail">
            <img :src="item.imgUrl" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgUrl && item.imgUrl.length > 0" />
          </div>
        </div>
        <!-- 图集、无图 -->
        <div class="news_item" v-if="item.contentType==6 && item.styleType == 1" @click="toDetail(item)">
          <div class="news_title" v-text="item.title"></div>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 图集、小图 -->
        <div class="news_item news_item_small" v-else-if="item.contentType==6 && ( item.styleType == 2 || item.styleType == 0)" @click="toDetail(item)">
          <div class="news_text">
            <div class="news_title" v-text="item.title"></div>
            <div class="news_info">
              <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
              <span class="source" v-text="appName" v-else></span>
              <span class="time" v-text="item.publishTime"></span>
            </div>
          </div>
          <div class="thumbnail">
            <img :src="item.imgList[0].url" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgList && item.imgList.length > 0 && item.imgList[0].url.length>0" />
            <img :src="item.pictureUrls[0]" alt="" :onerror="imgLoadError(item)" v-else-if="!!item.pictureUrls && item.pictureUrls.length > 0 && item.pictureUrls[0].length>0" />
          </div>
        </div>
        <!-- 图集、大图 -->
        <div class="news_item news_item_big" v-else-if="item.contentType==6 && item.styleType == 3" @click="toDetail(item)">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <div class="news_big_img_box">
            <div class="news_big_img">
              <img :src="item.imgList[0].bigUrl" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgList && item.imgList.length > 0 && item.imgList[0].bigUrl.length>0" />
              <img :src="item.pictureUrls[0]" alt="" :onerror="imgLoadError(item)" v-else-if="!!item.pictureUrls && item.pictureUrls.length > 0 && item.pictureUrls[0].length>0" />
            </div>
          </div>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 图集、三图 -->
        <div class="news_item news_item_three" v-else-if="item.contentType==6 && item.styleType == 4" @click="toDetail(item)">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <van-row class="news_img_list" v-if="!!item.pictureUrls && item.pictureUrls.length > 0">
            <van-col span="8" v-for="(pic, i) in item.pictureUrls" :key="i">
              <div class="news_img_item">
                <div class="news_img_box">
                  <img :src="pic" alt="" :onerror="imgLoadError(item)" v-if="pic.length > 0" />
                </div>
              </div>
            </van-col>
          </van-row>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 专题、无图 -->
        <div class="news_item news_item_special" v-else-if="item.contentType==7 && item.styleType==1" @click="toDetail(item)">
          <div class="news_title" v-text="item.title"></div>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 专题、小图 -->
        <div class="news_item news_item_special news_item_small" v-else-if="item.contentType==7 && item.styleType==2" @click="toDetail(item)">
          <div class="news_text">
            <div class="news_title" v-text="item.title"></div>
            <div class="news_info">
              <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
              <span class="source" v-text="appName" v-else></span>
              <span class="time" v-text="item.publishTime"></span>
            </div>
          </div>
          <div class="thumbnail">
            <img :src="item.imgList[0].url" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgList && item.imgList.length > 0 && item.imgList[0].url.length>0" />
            <img :src="item.pictureUrls[0]" alt="" :onerror="imgLoadError(item)" v-else-if="!!item.pictureUrls && item.pictureUrls.length > 0 && item.pictureUrls[0].length>0" />
          </div>
        </div>
        <!-- 专题、大图 -->
        <div class="news_item news_item_special news_item_big" v-else-if="item.contentType==7 && item.styleType==3" @click="toDetail(item)">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <div class="news_big_img_box">
            <div class="news_big_img">
              <img :src="item.imgList[0].bigUrl" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgList && item.imgList.length > 0 && item.imgList[0].bigUrl.length>0" />
              <img :src="item.pictureUrls[0]" alt="" :onerror="imgLoadError(item)" v-else-if="!!item.pictureUrls && item.pictureUrls.length > 0 && item.pictureUrls[0].length>0" />
            </div>
          </div>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 专题、三图 -->
        <div class="news_item news_item_three" v-else-if="item.contentType==7 && item.styleType == 4" @click="toDetail(item)">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <van-row class="news_img_list" v-if="!!item.pictureUrls && item.pictureUrls.length > 0">
            <van-col span="8" v-for="(pic, i) in item.pictureUrls" :key="i">
              <div class="news_img_item">
                <div class="news_img_box">
                  <img :src="pic" alt="" :onerror="imgLoadError(item)" v-if="pic.length > 0" />
                </div>
              </div>
            </van-col>
          </van-row>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 专题、滚动、快讯、长图、滑块，默认小图显示 -->
        <div class="news_item news_item_special news_item_small" v-else-if="item.contentType==7" @click="toDetail(item)">
          <div class="news_text">
            <div class="news_title" v-text="item.title"></div>
            <div class="news_info">
              <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
              <span class="source" v-text="appName" v-else></span>
              <span class="time" v-text="item.publishTime"></span>
            </div>
          </div>
          <div class="thumbnail">
            <img :src="item.imgList[0].url" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgList && item.imgList.length > 0 && item.imgList[0].url.length>0" />
            <img :src="item.pictureUrls[0]" alt="" :onerror="imgLoadError(item)" v-else-if="!!item.pictureUrls && item.pictureUrls.length > 0 && item.pictureUrls[0].length>0" />
          </div>
        </div>
        <!-- 广告 无图 -->
        <div class="news_item news_item_ad" v-else-if="item.contentType == 8 && item.styleType == 1 " @click="toDetail(item)">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <div class="news_info">
            <span class="time" v-text="item.publishTime" v-if="item.publishTime.length > 0"></span>
          </div>
        </div>
        <!-- 广告 小图 -->
        <div class="news_item news_item_ad news_item_small" v-else-if="item.contentType == 8 && ( item.styleType == 2 || item.styleType == 0) " @click="toDetail(item)">
          <div class="news_text">
            <div class="news_title">
              <span v-text="item.title"></span>
            </div>
            <div class="news_info">
              <span class="time" v-text="item.publishTime" v-if="item.publishTime.length > 0"></span>
            </div>
          </div>
          <div class="thumbnail">
            <img :src="item.imgList[0].url" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgList && item.imgList.length > 0 && item.imgList[0].url.length>0" />
            <img :src="item.pictureUrls[0]" alt="" :onerror="imgLoadError(item)" v-else-if="!!item.pictureUrls && item.pictureUrls.length > 0 && item.pictureUrls[0].length>0" />
          </div>
        </div>
        <!-- 广告 大图 -->
        <div class="news_item news_item_ad" v-else-if="item.contentType == 8 && item.styleType == 3 " @click="toDetail(item)">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <div class="news_ad_img_box">
            <div class="news_ad_img">
              <img :src="item.imgList[0].bigUrl" alt="" :onerror="imgLoadError(item)" v-if="!!item.imgList && item.imgList.length > 0 && item.imgList[0].bigUrl.length>0" />
              <img :src="item.pictureUrls[0]" alt="" :onerror="imgLoadError(item)" v-else-if="!!item.pictureUrls && item.pictureUrls.length > 0 && item.pictureUrls[0].length>0" />
            </div>
          </div>
          <div class="news_info">
            <span class="time" v-text="item.publishTime" v-if="item.publishTime.length > 0"></span>
          </div>
        </div>
        <!-- 广告 三图 -->
        <div class="news_item news_item_ad news_item_three" v-else-if="item.contentType == 8 && item.styleType == 4 " @click="toDetail(item)">
          <div class="news_title">
            <span v-text="item.title"></span>
          </div>
          <van-row class="news_img_list">
            <van-col span="8" v-for="(pic, i) in item.pictureUrls" :key="i">
              <div class="news_img_item">
                <div class="news_img_box">
                  <img v-if="pic.length > 0" :src="pic" alt="" :onerror="imgLoadError(item)" />
                </div>
              </div>
            </van-col>
          </van-row>
          <div class="news_info">
            <span class="time" v-text="item.publishTime" v-if="item.publishTime.length > 0"></span>
          </div>
        </div>
        <!-- 视频 -->
        <div class="news_item news_item_video" v-else-if="item.contentType == 9">
          <div class="news_title" v-text="item.title" @click="toDetail(item)"></div>
          <div class="news_video_box" v-if="!!item.playInfo">
            <video :width="item.playInfo.videoWidth" :height="item.playInfo.videoHeight" :poster="item.playInfo.coverUrl" controls controlsList="nodownload" disablePictureInPicture>
              <source :src="item.playInfo.playUrl" type="video/mp4" />
            </video>
          </div>
          <div class="news_info">
            <span class="source" v-text="item.source" v-if="item.source && item.source.length > 0"></span>
            <span class="source" v-text="appName" v-else></span>
            <span class="time" v-text="item.publishTime"></span>
          </div>
        </div>
        <!-- 问卷、小图 -->
        <div class="news_item news_item_questionnaire news_item_small" v-else-if="item.contentType == 10 && ( item.styleType == 2 || item.styleType == 0)" @click="toDetail(item)">
          <div class="news_text">
            <div class="news_title" v-text="item.title"></div>
            <div class="news_info">
              <span class="time" style="margin:0;">时间：{{ item.startTime.substring(0,10) }}—{{ item.imgList[0].endTime.substring(0,10) }}</span>
            </div>
          </div>
          <div class="thumbnail">
            <img :src="item.imgList[0].url" :onerror="imgLoadError(item)" v-if="item.imgList && item.imgList.length > 0 && item.imgList[0].url.length>0" alt="" />
          </div>
        </div>
        <!-- 问卷、大图 -->
        <div class="news_item news_item_questionnaire" v-else-if="item.contentType == 10 && item.styleType == 3" @click="toDetail(item)">
          <div class="news_title" v-text="item.title"></div>
          <div class="news_questionnaire_img_box">
            <div class="news_questionnaire_img">
              <img :src="item.imgList[0].bigUrl" :onerror="imgLoadError(item)" v-if="item.imgList && item.imgList.length > 0 && item.imgList[0].bigUrl.length>0" alt="" />
            </div>
            <div class="questionnaire_info">
              <span class="status not_start" v-if="item.status == 1">未开始</span>
              <span class="status playing" v-else-if="item.status == 2">正在进行</span>
              <span class="status end" v-else-if="item.status == 3">问卷结束</span>
              <span class="time">{{ item.startTime.substring(0,10) }} — {{ item.imgList[0].endTime.substring(0,10) }}</span>
            </div>
          </div>
        </div>
        <!-- 报料 -->
        <div class="news_item news_item_report" v-else-if="item.contentType == 16" @click="toDetail(item)">
          <div class="news_item_report_info">
            <div class="portrait">
              <img :src="item.memberResourceUrl" alt="" :onerror="imgLoadError(item)" />
            </div>
            <div class="text">
              <div class="name" v-text="item.memberNickname"></div>
              <div class="time" v-text="item.publishTime"></div>
            </div>
            <div class="type">报料</div>
          </div>
          <div class="news_item_report_desc">
            <p v-html="item.description.replace(/<\/?.+?>/g, '')"></p>
          </div>
          <div class="news_item_report_pics" v-if="!!item.imgList && item.imgList.length>0 && !!item.imgList[0].url && item.imgList[0].url.length>0">
            <van-row class="pic_list">
              <van-col span="8" v-for="(pic, i) in item.imgList[0].url" :key="i">
                <div class="pic_item" v-if="i < 3">
                  <div class="pic_box">
                    <img :src="pic" alt="" :onerror="imgLoadError(item)" />
                  </div>
                </div>
              </van-col>
            </van-row>
            <div class="news_item_report_pics_num" v-if="item.imgList[0].url.length > 3" v-text="item.imgList[0].url.length + '图'"></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { deepClone } from "@/utils";
export default {
  name: "RelatedNews",
  props: {
    contentList: {
      type: Array,
      default: [],
    },
  },
  computed: {
    ...mapState("app", ["appName"]),
  },
  data() {
    return {
      headerHidden: false, // 是否隐藏顶部
      newsList: [],
    };
  },
  watch: {
    contentList: {
      handler(newVal, oldVal) {
        this.newsList = deepClone(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 跳转详情页 */
    toDetail(data) {
      if (data.contentType == 1) {
        // 活动
        if (data.whetherToLink) {
          window.location.href = data.externalLinkURL;
        } else {
          var q = {
            contentType: data.contentType || 1,
            activityId: data.id,
            cId: data.contentId || 0,
            fromFlag: data.fromFlag || 0,
          }
          if (!!this.headerHidden) {
            q = Object.assign(q, { client: 1 });
          }
          this.$router.push({
            path: "/activity_detail",
            query: q,
          });
        }
      } else if (data.contentType == 3) {
        // 投票
        var q = {
          contentType: data.contentType || 3,
          id: data.id,
          cId: data.contentId || 0,
          fromFlag: data.fromFlag || 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/vote_detail",
          query: q,
        });
      } else if (data.contentType == 4) {
        // 直播
        var q = {
          contentType: data.contentType,
          id: data.id,
          fromFlag: data.fromFlag || 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/live_detail",
          query: q,
        });
      } else if (data.contentType == 5) {
        // 图文
        var q = {
          contentType: data.contentType,
          contentId: data.contentId,
          cId: data.id,
          fromFlag: data.fromFlag || 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/news_detail",
          query: q,
        });
      }
      else if (data.contentType == 6) {
        // 图集
        var q = {
          contentType: data.contentType,
          contentId: data.contentId,
          fromFlag: data.fromFlag || 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/gallery_detail",
          query: q,
        });
      } else if (data.contentType == 7) {
        // 专题
        var q = {
          contentType: data.contentType,
          contentId: data.contentId,
          fromFlag: data.fromFlag || 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/special_detail",
          query: q,
        });
      } else if (data.contentType == 8) {
        // 广告 type=1 外链
        if (data.type == 1) {
          if (!!data.link && data.link.length > 0) {
            window.open(data.link, "_self");
          } else if (!!data.sourceURL && data.sourceURL.length > 0) {
            window.open(data.sourceURL, "_self");
          }
        }
        // 广告 type=2 图文内容
        else if (data.type == 2) {
          var q = {
            adId: data.originalId,
          }
          if (!!this.headerHidden) {
            q = Object.assign(q, { client: 1 });
          }
          this.$router.push({
            path: "/ad_detail",
            query: q,
          });
        }
        // 广告 type=7 内链
        else if (data.type == 7) {
          this.adToDetail(data);
        } else {
          // 其他类型的暂不处理
        }
      } else if (data.contentType == 9) {
        // 视频
        var q = {
          contentType: data.contentType,
          contentId: data.contentId,
          fromFlag: data.fromFlag || 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/video_detail",
          query: q,
        });
      } else if (data.contentType == 10) {
        // 问卷
        var q = {
          contentType: data.contentType,
          contentId: data.id,
          fromFlag: data.fromFlag || 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/questionnaire_detail",
          query: q,
        });
      } else if (data.contentType == 16) {
        // 报料
        var q = {
          contentType: data.contentType,
          contentId: data.id,
          fromFlag: data.fromFlag || 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/report_detail",
          query: q,
        });
      }
    },
    /* 广告内链，跳转详情 */
    adToDetail(data) {
      /* 活动 */
      if (data.resultContent.adContentType == 1) {
        var q = {
          contentType: data.resultContent.adContentType,
          activityId: data.resultContent.adContentId,
          cId: 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/activity_detail",
          query: q,
        });
      }
      /* 抽奖 */
      else if (data.resultContent.adContentType == 2) {
        var q = {
          contentType: data.resultContent.adContentType,
          freeFlag: 0,
          drawRaffleId: data.resultContent.adContentId,
          type: 0
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/raffle_detail",
          query: q,
        });
      }
      /* 投票 */
      else if (data.resultContent.adContentType == 3) {
        var q = {
          contentType: data.resultContent.adContentType,
          id: data.resultContent.adContentId,
          cId: data.resultContent.adContentId || 0,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/vote_detail",
          query: q,
        });
      }
      /* 直播 */
      else if (data.resultContent.adContentType == 4) {
        var q = {
          contentType: data.resultContent.adContentType,
          id: data.resultContent.adContentId,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/live_detail",
          query: q,
        });
      }
      /* 图文 */
      else if (data.resultContent.adContentType == 5) {
        var q = {
          contentType: data.resultContent.adContentType,
          contentId: data.resultContent.adContentId,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/news_detail",
          query: q,
        });
      }
      /* 图集 */
      else if (data.resultContent.adContentType == 6) {
        var q = {
          contentType: data.resultContent.adContentType,
          contentId: data.resultContent.adContentId,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/gallery_detail",
          query: q,
        });
      }
      /* 专题 */
      else if (data.resultContent.adContentType == 7) {
        var q = {
          contentType: data.resultContent.adContentType,
          contentId: data.resultContent.adContentId,
          cId: data.resultContent.adoriginalContentId,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/special_detail",
          query: q,
        });
      }
      /* 视频 */
      else if (data.resultContent.adContentType == 9) {
        var q = {
          contentType: data.resultContent.adContentType,
          contentId: data.resultContent.adContentId,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/video_detail",
          query: q,
        });
      }
      /* 问卷 */
      else if (data.resultContent.adContentType == 10) {
        var q = {
          contentType: data.resultContent.adContentType,
          contentId: data.resultContent.adContentId,
        }
        if (!!this.headerHidden) {
          q = Object.assign(q, { client: 1 });
        }
        this.$router.push({
          path: "/questionnaire_detail",
          query: q,
        });
      }
    },
  },
  created() {
    this.newsList = deepClone(this.contentList);
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "client")) {
      if (query.client == 1 || query.client == '1' || query.client == true || query.client == 'true') {
        this.headerHidden = true;
      }
    }
  },
};
</script>
<style scoped lang="scss">
.related_box {
  margin-bottom: 16px;
  .related_news {
    position: relative;
    width: 100%;
    line-height: 20px;
    padding: 15px 10px 10px;
    border-bottom: 1px solid #eeeef0;
    color: #323232;
    font-size: 15px;
    font-weight: bold;
    &::before {
      position: absolute;
      left: 0;
      top: 17px;
      display: block;
      width: 4px;
      height: 16px;
      background-color: #318bff;
      content: "";
      border-radius: 2px;
    }
  }
}
</style>